'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.updatePageOffset_E76660v1 = updatePageOffset_E76660v1;
exports.updateMapPageOffset_E76660v1 = updateMapPageOffset_E76660v1;
exports.updateListPageOffset_E76660v1 = updateListPageOffset_E76660v1;
exports.updateStitek_3D7ECFv1 = updateStitek_3D7ECFv1;
exports.updateMapStitek_3D7ECFv1 = updateMapStitek_3D7ECFv1;
exports.updateListStitek_3D7ECFv1 = updateListStitek_3D7ECFv1;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:39:16Z                      #

// ##############################################################

function updatePageOffset_E76660v1(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'PageOffsetVO'
    });

    return result;
}

function updateMapPageOffset_E76660v1(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updatePageOffset_E76660v1(data[key]);
    });
    return result;
}

function updateListPageOffset_E76660v1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePageOffset_E76660v1);
}

function updateStitek_3D7ECFv1(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'StitekVO'
    });

    if (typeof data.adresat !== "undefined" && data.adresat) {
        result.adresat = { id: result.adresat.id };
    }
    if (typeof data.adresa !== "undefined" && data.adresa) {
        result.adresa = { id: result.adresa.id };
    }

    return result;
}

function updateMapStitek_3D7ECFv1(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updateStitek_3D7ECFv1(data[key]);
    });
    return result;
}

function updateListStitek_3D7ECFv1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateStitek_3D7ECFv1);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2dlbi9vYmFsa3kvVXBkYXRlTWV0aG9kcy5qc3giXSwibmFtZXMiOlsidXBkYXRlUGFnZU9mZnNldF9FNzY2NjB2MSIsInVwZGF0ZU1hcFBhZ2VPZmZzZXRfRTc2NjYwdjEiLCJ1cGRhdGVMaXN0UGFnZU9mZnNldF9FNzY2NjB2MSIsInVwZGF0ZVN0aXRla18zRDdFQ0Z2MSIsInVwZGF0ZU1hcFN0aXRla18zRDdFQ0Z2MSIsInVwZGF0ZUxpc3RTdGl0ZWtfM0Q3RUNGdjEiLCJkYXRhIiwicmVzdWx0IiwiZm9yRWFjaCIsImtleSIsIm1hcCIsImFkcmVzYXQiLCJpZCIsImFkcmVzYSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7UUFRZ0JBLHlCLEdBQUFBLHlCO1FBYUFDLDRCLEdBQUFBLDRCO1FBV0FDLDZCLEdBQUFBLDZCO1FBT0FDLHFCLEdBQUFBLHFCO1FBbUJBQyx3QixHQUFBQSx3QjtRQVdBQyx5QixHQUFBQSx5Qjs7OztBQXJFaEI7O0FBRUE7O0FBRUE7O0FBRUE7O0FBRU8sU0FBU0wseUJBQVQsQ0FBbUNNLElBQW5DLEVBQXlDO0FBQzVDLFFBQUlBLFFBQVEsSUFBWixFQUFrQjtBQUNkLGVBQU9BLElBQVA7QUFDSDtBQUNELFFBQUlDLG9DQUNHRCxJQURIO0FBRUEsa0JBQVVBLEtBQUssUUFBTCxJQUFpQkEsS0FBSyxRQUFMLENBQWpCLEdBQWtDO0FBRjVDLE1BQUo7O0FBTUEsV0FBT0MsTUFBUDtBQUNIOztBQUVNLFNBQVNOLDRCQUFULENBQXNDSyxJQUF0QyxFQUE0QztBQUMvQyxRQUFJQSxRQUFRLElBQVosRUFBa0I7QUFDZCxlQUFPQSxJQUFQO0FBQ0g7QUFDRCxRQUFNQyxTQUFTLEVBQWY7QUFDQSx3QkFBWUQsSUFBWixFQUFrQkUsT0FBbEIsQ0FBMEIsZUFBTztBQUM3QkQsZUFBT0UsR0FBUCxJQUFjVCwwQkFBMEJNLEtBQUtHLEdBQUwsQ0FBMUIsQ0FBZDtBQUNILEtBRkQ7QUFHQSxXQUFPRixNQUFQO0FBQ0g7O0FBRU0sU0FBU0wsNkJBQVQsQ0FBdUNJLElBQXZDLEVBQTZDO0FBQ2hELFFBQUlBLFFBQVEsSUFBWixFQUFrQjtBQUNkLGVBQU9BLElBQVA7QUFDSDtBQUNELFdBQU9BLEtBQUtJLEdBQUwsQ0FBU1YseUJBQVQsQ0FBUDtBQUNIOztBQUVNLFNBQVNHLHFCQUFULENBQStCRyxJQUEvQixFQUFxQztBQUN4QyxRQUFJQSxRQUFRLElBQVosRUFBa0I7QUFDZCxlQUFPQSxJQUFQO0FBQ0g7QUFDRCxRQUFJQyxvQ0FDR0QsSUFESDtBQUVBLGtCQUFVQSxLQUFLLFFBQUwsSUFBaUJBLEtBQUssUUFBTCxDQUFqQixHQUFrQztBQUY1QyxNQUFKOztBQUtBLFFBQUksT0FBT0EsS0FBS0ssT0FBWixLQUF3QixXQUF4QixJQUF1Q0wsS0FBS0ssT0FBaEQsRUFBeUQ7QUFDckRKLGVBQU9JLE9BQVAsR0FBaUIsRUFBRUMsSUFBSUwsT0FBT0ksT0FBUCxDQUFlQyxFQUFyQixFQUFqQjtBQUNIO0FBQ0QsUUFBSSxPQUFPTixLQUFLTyxNQUFaLEtBQXVCLFdBQXZCLElBQXNDUCxLQUFLTyxNQUEvQyxFQUF1RDtBQUNuRE4sZUFBT00sTUFBUCxHQUFnQixFQUFFRCxJQUFJTCxPQUFPTSxNQUFQLENBQWNELEVBQXBCLEVBQWhCO0FBQ0g7O0FBRUQsV0FBT0wsTUFBUDtBQUNIOztBQUVNLFNBQVNILHdCQUFULENBQWtDRSxJQUFsQyxFQUF3QztBQUMzQyxRQUFJQSxRQUFRLElBQVosRUFBa0I7QUFDZCxlQUFPQSxJQUFQO0FBQ0g7QUFDRCxRQUFNQyxTQUFTLEVBQWY7QUFDQSx3QkFBWUQsSUFBWixFQUFrQkUsT0FBbEIsQ0FBMEIsZUFBTztBQUM3QkQsZUFBT0UsR0FBUCxJQUFjTixzQkFBc0JHLEtBQUtHLEdBQUwsQ0FBdEIsQ0FBZDtBQUNILEtBRkQ7QUFHQSxXQUFPRixNQUFQO0FBQ0g7O0FBRU0sU0FBU0YseUJBQVQsQ0FBbUNDLElBQW5DLEVBQXlDO0FBQzVDLFFBQUlBLFFBQVEsSUFBWixFQUFrQjtBQUNkLGVBQU9BLElBQVA7QUFDSDtBQUNELFdBQU9BLEtBQUtJLEdBQUwsQ0FBU1AscUJBQVQsQ0FBUDtBQUNIIiwiZmlsZSI6IlVwZGF0ZU1ldGhvZHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyAjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjI1xuXG4vLyAjICAgICAgICAgICAgIEdFTkVST1ZBTsOdIEvDk0QsIE5FTU9ESUZJS09WQVQhISEhICAgICAgICAgICAgICAjXG5cbi8vICMgICAgICAgICAgICAgICAgICAyMDI1LTAxLTA3VDE3OjM5OjE2WiAgICAgICAgICAgICAgICAgICAgICAjXG5cbi8vICMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjXG5cbmV4cG9ydCBmdW5jdGlvbiB1cGRhdGVQYWdlT2Zmc2V0X0U3NjY2MHYxKGRhdGEpIHtcbiAgICBpZiAoZGF0YSA9PSBudWxsKSB7XG4gICAgICAgIHJldHVybiBkYXRhO1xuICAgIH1cbiAgICBsZXQgcmVzdWx0ID0ge1xuICAgICAgICAuLi5kYXRhLFxuICAgICAgICAnQGNsYXNzJzogZGF0YVsnQGNsYXNzJ10gPyBkYXRhWydAY2xhc3MnXSA6ICdQYWdlT2Zmc2V0Vk8nLFxuICAgIH07XG5cblxuICAgIHJldHVybiByZXN1bHQ7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB1cGRhdGVNYXBQYWdlT2Zmc2V0X0U3NjY2MHYxKGRhdGEpIHtcbiAgICBpZiAoZGF0YSA9PSBudWxsKSB7XG4gICAgICAgIHJldHVybiBkYXRhO1xuICAgIH1cbiAgICBjb25zdCByZXN1bHQgPSB7fTtcbiAgICBPYmplY3Qua2V5cyhkYXRhKS5mb3JFYWNoKGtleSA9PiB7XG4gICAgICAgIHJlc3VsdFtrZXldID0gdXBkYXRlUGFnZU9mZnNldF9FNzY2NjB2MShkYXRhW2tleV0pO1xuICAgIH0pO1xuICAgIHJldHVybiByZXN1bHQ7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB1cGRhdGVMaXN0UGFnZU9mZnNldF9FNzY2NjB2MShkYXRhKSB7XG4gICAgaWYgKGRhdGEgPT0gbnVsbCkge1xuICAgICAgICByZXR1cm4gZGF0YTtcbiAgICB9XG4gICAgcmV0dXJuIGRhdGEubWFwKHVwZGF0ZVBhZ2VPZmZzZXRfRTc2NjYwdjEpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gdXBkYXRlU3RpdGVrXzNEN0VDRnYxKGRhdGEpIHtcbiAgICBpZiAoZGF0YSA9PSBudWxsKSB7XG4gICAgICAgIHJldHVybiBkYXRhO1xuICAgIH1cbiAgICBsZXQgcmVzdWx0ID0ge1xuICAgICAgICAuLi5kYXRhLFxuICAgICAgICAnQGNsYXNzJzogZGF0YVsnQGNsYXNzJ10gPyBkYXRhWydAY2xhc3MnXSA6ICdTdGl0ZWtWTycsXG4gICAgfTtcblxuICAgIGlmICh0eXBlb2YgZGF0YS5hZHJlc2F0ICE9PSBcInVuZGVmaW5lZFwiICYmIGRhdGEuYWRyZXNhdCkge1xuICAgICAgICByZXN1bHQuYWRyZXNhdCA9IHsgaWQ6IHJlc3VsdC5hZHJlc2F0LmlkIH07XG4gICAgfVxuICAgIGlmICh0eXBlb2YgZGF0YS5hZHJlc2EgIT09IFwidW5kZWZpbmVkXCIgJiYgZGF0YS5hZHJlc2EpIHtcbiAgICAgICAgcmVzdWx0LmFkcmVzYSA9IHsgaWQ6IHJlc3VsdC5hZHJlc2EuaWQgfTtcbiAgICB9XG5cbiAgICByZXR1cm4gcmVzdWx0O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gdXBkYXRlTWFwU3RpdGVrXzNEN0VDRnYxKGRhdGEpIHtcbiAgICBpZiAoZGF0YSA9PSBudWxsKSB7XG4gICAgICAgIHJldHVybiBkYXRhO1xuICAgIH1cbiAgICBjb25zdCByZXN1bHQgPSB7fTtcbiAgICBPYmplY3Qua2V5cyhkYXRhKS5mb3JFYWNoKGtleSA9PiB7XG4gICAgICAgIHJlc3VsdFtrZXldID0gdXBkYXRlU3RpdGVrXzNEN0VDRnYxKGRhdGFba2V5XSk7XG4gICAgfSk7XG4gICAgcmV0dXJuIHJlc3VsdDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHVwZGF0ZUxpc3RTdGl0ZWtfM0Q3RUNGdjEoZGF0YSkge1xuICAgIGlmIChkYXRhID09IG51bGwpIHtcbiAgICAgICAgcmV0dXJuIGRhdGE7XG4gICAgfVxuICAgIHJldHVybiBkYXRhLm1hcCh1cGRhdGVTdGl0ZWtfM0Q3RUNGdjEpO1xufVxuIl19